import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AngularFireModule } from '@angular/fire';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireMessagingModule } from '@angular/fire/messaging';

import { environment } from 'src/environments/environment';

import { StorageService } from './storage/storage.service';
import { AuthService } from './auth/services/auth.service';
import { AuthProxyService } from './auth/services/auth-proxy.service';
import { MessagingService } from './notifications/messaging.service';
import { AuthenticationGuard } from './auth/services/authentication.guard';
import { AuthInterceptorProvider } from './auth/services/auth-interceptor.service';
import { RoleGuard } from './auth/services/role.guard';


@NgModule({
	declarations: [],
	imports: [
		CommonModule,
		AngularFireModule.initializeApp(environment.firebase),
		AngularFireAuthModule,
		AngularFireMessagingModule,
	],
	providers: [
		StorageService,
		AuthService,
		AuthProxyService,
		AuthenticationGuard,
		RoleGuard,
		AuthInterceptorProvider,
		MessagingService
	]
})
export class CoreModule {

	static forRoot(): ModuleWithProviders {
		return {
			ngModule: CoreModule,
			providers: [
				StorageService,
				AuthService,
				AuthProxyService,
				AuthenticationGuard,
				AuthInterceptorProvider,
				MessagingService
			]
		};
	}

	constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
		if (parentModule) {
			throw new Error(
				'CoreModule is already loaded. Import it in the AppModule only');
		}
	}
}
